export default __webpack_public_path__ + "static/media/red-hat-display-v4-latin-ext_latin-regular.9e52ff44.woff";